import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { Magnet } from "lucide-react";
import MagnetOffIcon from "./MagnetOffIcon";
import { useTranslationApp } from "../../../lib/i18next";
import { TEMPLATES_ALIGNMENT_GUIDES } from "../../../i18n/keysTranslations";

const AlignmentGuidesToggle = ({ enabled, onToggle, size = 16 }) => {
  const { t } = useTranslationApp();
  return (
    <Tooltip title={t(TEMPLATES_ALIGNMENT_GUIDES)}>
      <span>
        <IconButton
          size="small"
          aria-label={t(TEMPLATES_ALIGNMENT_GUIDES)}
          onClick={onToggle}
          sx={{
            width: 28,
            height: 28,
            border: 0,
            borderRadius: "7px",
            color: "#18181B",
            "&:hover": { bgcolor: "#F4F4F5" },
          }}
        >
          {enabled ? <Magnet size={size} /> : <MagnetOffIcon size={size} />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default AlignmentGuidesToggle;
